import React, { ReactElement } from 'react';
import { graphql } from 'gatsby';

import Addons from '../components/AddonCatalog/Addons';
import SEO from '../components/SEO';
import { KeyValue } from '../types/common.types';

interface Props {
  data: KeyValue;
}

const AddonsPage = ({ data }: Props): ReactElement => {
  return (
    <>
      <SEO title="Add-ons" />
      <Addons data={data} />
    </>
  );
};

export default AddonsPage;

export const query = graphql`
  {
    allAddon {
      edges {
        node {
          flowType
          contract
          groupName
          id
          onetimePrice
          phoneList
          price
          productDescription
          productSpecContainmentID
          productTitle
          ranking
          salesRanking
          atomic
          type
          promotionText
          requiredDevice
          addonPopupTitle
          addonPopupMessage
          addonPopupButtonLabel
          categoryId
          categorySequence
        }
      }
    }
    allAddonGroup {
      edges {
        node {
          flowType
          displayName
          icon
          iconImage {
            src
          }
          setupFee
          shortDescription
          categoryId
          categorySequence
          type
        }
      }
    }
    allAddonPreTick(filter: { productId: { ne: "", nin: [null] } }) {
      edges {
        node {
          phoneList
          phoneSpecific
          planIds
          segment
          productId
          variationIds
          transactionVariationIds {
            gaVariationIds
            portinVariationIds
            reconVariationIds
          }
          transactionSpecific
          type
        }
      }
    }
    allPhone(filter: { brand: { eq: "Apple" } }) {
      edges {
        node {
          id
          groupId
          productId
          variants {
            productId
          }
        }
      }
    }
    addonSimOnlyPlan {
      data {
        addonId
        price
        quantity
        unit
      }
      sms {
        addonId
        price
        quantity
        unit
      }
      talktime {
        addonId
        price
        quantity
        unit
      }
    }
    simCardOptions {
      changeSIM {
        changeSIMOptionEnabled
        title
        blueNotificationMessage
        changeSIMOption1
        changeSIMOption2
        ctaLabel
      }
      changeSIM4GTo5G {
        changeSIMOptionEnabled
        title
        blueNotificationMessage
        changeSIMOption1
        changeSIMOption2
        ctaLabel
      }
    }
    allPlanGroup {
      edges {
        node {
          enableAccessoriesPageForCIS
          enableAccessoriesPageForRES
          groupName
        }
      }
    }
    allChooseSimOptions {
      edges {
        node {
          notAvailable
          footerNotAvailable
          simTitle
          simTypeId
          simDetails {
            transactionType
            descWithDevice
            descWithoutDevice
            footerWithDevice
            footerWithoutDevice
            simPrice
          }
        }
      }
    }
    allVariableConfig {
      edges {
        node {
          name
          value
        }
      }
    }
  }
`;
